

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 22 6","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, rest), ["\n    ", h('g', {"id":"svg-menu-dots-WVa6d7V","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}, ["\n        ", h('path', {"d":"M3,6 C4.65685425,6 6,4.65685425 6,3 C6,1.34314575 4.65685425,0 3,0 C1.34314575,0 0,1.34314575 0,3 C0,4.65685425 1.34314575,6 3,6 Z M11,6 C12.6568542,6 14,4.65685425 14,3 C14,1.34314575 12.6568542,0 11,0 C9.34314575,0 8,1.34314575 8,3 C8,4.65685425 9.34314575,6 11,6 Z M19,6 C20.6568542,6 22,4.65685425 22,3 C22,1.34314575 20.6568542,0 19,0 C17.3431458,0 16,1.34314575 16,3 C16,4.65685425 17.3431458,6 19,6 Z","id":"svg-menu-dots-jTGVLxo","fill":"currentColor"}, []), "\n    "]), "\n"]);
};

        